interface InputProps {
    placeholder: string,
    type?: React.HTMLInputTypeAttribute,
    id?: string,
    required?: boolean,
    autocomplete?: React.HTMLInputAutoCompleteAttribute,
    ref?: React.Ref<HTMLInputElement>
    className?: string,
    value?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function BaseInput(
    {
        placeholder,
        type = "text",
        autocomplete = undefined,
        ref = undefined,
        required = false,
        id = undefined,
        className = "",
        value,
        onChange
    }: InputProps
) {
    return <input
        value={value}
        onChange={onChange}
        id={id || placeholder.toLowerCase().replace(" ", "-")}
        name={id || placeholder.toLowerCase().replace(" ", "-")}
        ref={ref}
        required={required}
        type={type}
        placeholder={placeholder}
        className={'bg-darkForeground px-2 py-1 rounded-xl outline-none ' + className}
        autoComplete={autocomplete}
    />
}

export default BaseInput